export default __webpack_public_path__ + "static/media/wireframe.3c43a664.png";